import type { GrupoExtratoPagarmeModel, TransacaoPagarmeModel } from "../../../services/extratoPagarmeFornecedor"

export type { GrupoExtratoPagarmeModel, TransacaoPagarmeModel }

export type ExtratoPagarmeFornecedorModel = {
    dataInicio: string
    dataFim: string
    grupos: GrupoExtratoPagarmeModel[]
    saldo: string
}

const hoje = () => {
    const d = new Date()
    return d.toISOString().slice(0, 10)
}

export const ExtratoPagarmeFornecedorInicial: ExtratoPagarmeFornecedorModel = {
    dataInicio: hoje(),
    dataFim: hoje(),
    grupos: [],
    saldo: "",
}
